import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ProcessSection from "@/components/ProcessSection";
import ServiceAreas from "@/components/ServiceAreas";
import Testimonials from "@/components/Testimonials";
import PricingSection from "@/components/PricingSection";
import ContactBooking from "@/components/ContactBooking";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Helmet>
        <title>Water Tank Cleaning Services in Gurugram | TankBuddy</title>
        <meta name="description" content="Book professional water tank cleaning in Gurugram. Overhead & underground tanks. Same-day service. ✓ Certified ✓ Eco-friendly ✓ Affordable — TankBuddy" />
        <meta name="keywords" content="water tank cleaning Gurugram, tank cleaning Gurgaon, overhead tank cleaning, underground tank cleaning Gurgaon" />
        <link rel="canonical" href="https://www.tankbuddy.in/" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.tankbuddy.in/" />
        <meta property="og:title" content="Water Tank Cleaning Services in Gurugram | TankBuddy" />
        <meta property="og:description" content="Book professional water tank cleaning in Gurugram. Overhead & underground tanks. Same-day service. ✓ Certified ✓ Eco-friendly ✓ Affordable — TankBuddy" />
        <meta name="geo.region" content="IN-HR" />
        <meta name="geo.placename" content="Gurugram" />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "TankBuddy",
            "telephone": "+91-9891315777",
            "url": "https://www.tankbuddy.in",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Gurugram",
              "addressRegion": "Haryana",
              "postalCode": "122001",
              "addressCountry": "IN"
            },
            "openingHours": "Mo-Su 08:00-20:00",
            "priceRange": "₹₹",
            "areaServed": "Gurugram",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Tank Cleaning Services",
              "itemListElement": [
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Overhead Water Tank Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Underground Water Tank Cleaning"}},
                {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "Commercial Tank Cleaning"}}
              ]
            }
          }
        `}</script>
      </Helmet>
      <Header />
      <HeroSection />
      <ServicesSection />
      <WhyChooseUs />
      <ProcessSection />
      <ServiceAreas />
      <Testimonials />
      <PricingSection />
      <ContactBooking />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
